import Plyr from 'plyr';

export default () => {
  new Plyr('.js-video-player');
}
